import { Button, CircularProgress, Grid, Typography } from "@material-ui/core";
import * as React from "react";
import { useState } from "react";
import { ErrorModal } from "../../../../../components/modals/error-modal";
import MesfModal from "../../../../../components/modals/modal.mesf";
import { deleteEmailAddress } from "../../../emailTopics/repositories/EmailTopicsRepository";
import { useEmailAddressesContext } from "../../context/EmailAddressesContext";

type Props = {
	show: boolean;
	onHide: (shouldUpdate: boolean) => void;
};

export const DeleteEmailAddress = ({ show, onHide }: Props) => {
	const [isSubmitLoading, setIsSubmitLoading] = useState(false);
	const [error, setError] = useState("");
	const {
		state: { addressSelected },
	} = useEmailAddressesContext();

	const onDelete = async () => {
		if (!addressSelected) return;

		setIsSubmitLoading(true);
		try {
			await deleteEmailAddress(addressSelected.EmailAddressId);
			onHide(true);
		} catch (e: any) {
			setError(e?.message || "Error deleting email address");
		} finally {
			setIsSubmitLoading(false);
		}
	};

	return (
		<>
			<ErrorModal error={error} onHide={() => setError("")} />
			<MesfModal
				title="DELETE EMAIL ADDRESS"
				open={show}
				handleClose={() => onHide(false)}
				id="delete-email-address-modal"
				maxWidth="sm"
			>
				<MesfModal.Content style={{ padding: "15px 30px 0" }}>
					<Typography>
						Delete <strong>{addressSelected?.Address}</strong>? It stops
						receiving every topic it is assigned to.
					</Typography>
				</MesfModal.Content>
				<MesfModal.Actions>
					<Grid
						container
						spacing={2}
						justifyContent="flex-end"
						style={{ padding: "1rem" }}
					>
						<Grid item md={4} xs={12}>
							<Button
								fullWidth
								variant="contained"
								onClick={() => onHide(false)}
								disabled={isSubmitLoading}
							>
								CANCEL
							</Button>
						</Grid>
						<Grid item md={4} xs={12}>
							<Button
								fullWidth
								variant="contained"
								color="secondary"
								onClick={onDelete}
								disabled={isSubmitLoading}
							>
								{isSubmitLoading ? <CircularProgress size={24} /> : "DELETE"}
							</Button>
						</Grid>
					</Grid>
				</MesfModal.Actions>
			</MesfModal>
		</>
	);
};
